import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { ColorPickerField, NumberField } from '@qfa/forms';
import { LocationFormContext } from '../../context';
import { DEFAULT_POLYGON_COLOR, DEFAULT_POLYGON_OPACITY } from '../../const';

export const usePolygonGeometryState = (disabled?: boolean) => {
  const { t } = useTranslation(['locations', 'common']);
  const { values, setValues, setDirty } = useContext(LocationFormContext);

  const polygonColor = values.color ?? DEFAULT_POLYGON_COLOR;
  const polygonOpacity = values.opacity ?? DEFAULT_POLYGON_OPACITY;

  const sectionOptions = useMemo(
    () => ({
      fieldNames: ['color, opacity'],
      name: t('locationGeometry'),
      hashRoute: 'locationGeometry',
      sectionId: 'locationGeometry',
      children: (
        <Box>
          <ColorPickerField
            type='colorPicker'
            id='color'
            name='color'
            label={t('common:color')}
            pickerZIndex={2}
            disabled={disabled}
            value={polygonColor}
            onChange={(_, value) => {
              setValues((prev) => ({
                ...prev,
                color: value,
              }));
              setDirty('color', true);
            }}
          />
          <NumberField
            type='number'
            id='opacity'
            name='opacity'
            label={t('common:opacity')}
            min={0}
            max={1}
            step={0.1}
            useStepper
            disabled={disabled}
            value={polygonOpacity}
            onChange={(_, value) => {
              setValues((prev) => ({
                ...prev,
                opacity: Number.parseFloat(value),
              }));
              setDirty('opacity', true);
            }}
          />
        </Box>
      ),
    }),
    [disabled, polygonColor, polygonOpacity, setValues, setDirty, t]
  );

  return { polygonColor, polygonOpacity, sectionOptions };
};
